import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Facebook, Linkedin, Lock } from 'lucide-react';

export const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Accueil', path: '/' },
    { name: 'Programmes', path: '/programmes' },
    { name: 'Partenariat École', path: '/partenariat-ecole' },
    { name: 'Activités', path: '/activites' },
    { name: 'Contact', path: '/contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled ? 'bg-white/95 backdrop-blur-md shadow-md' : 'bg-white shadow-sm'
      }`}
      data-testid="site-header"
    >
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="flex h-20 items-center justify-between">
          <Link to="/" className="flex items-center space-x-3 group flex-shrink-0" data-testid="logo-link">
            <img
              src="https://customer-assets.emergentagent.com/job_techkids-learn-1/artifacts/2efozgua_471419268_122203530860204093_7119326466186742520_n-2.jpg"
              alt="Ludotech Robotics Logo"
              className="h-14 w-auto transition-transform duration-300 group-hover:scale-105"
            />
            <span className="font-heading text-xl font-extrabold text-slate-800 hidden sm:block">Ludotech Robotics</span>
          </Link>

          <nav className="hidden lg:flex items-center space-x-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-${link.name.toLowerCase().replace(/\s+/g, '-').replace(/é/g, 'e')}`}
                className={`px-3 py-2 rounded-lg text-sm font-semibold transition-all duration-200 ${
                  isActive(link.path)
                    ? 'text-[#1B6FE3] bg-blue-50'
                    : 'text-slate-700 hover:text-[#1B6FE3] hover:bg-blue-50/50'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </nav>

          <div className="hidden lg:flex items-center space-x-3">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-[#1B6FE3] transition-colors">
              <Facebook size={18} />
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-[#1B6FE3] transition-colors">
              <Linkedin size={18} />
            </a>
            <Link
              to="/contact"
              data-testid="cta-inscription-header"
              className="btn-primary text-sm"
            >
              Inscrire mon enfant
            </Link>
            <Link
              to="/login"
              className="flex items-center text-sm text-slate-600 hover:text-[#1B6FE3] transition-colors font-semibold"
            >
              <Lock size={14} className="mr-1.5" />
              Intranet
            </Link>
          </div>

          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden p-2 rounded-lg hover:bg-slate-100 transition-colors"
            data-testid="mobile-menu-button"
          >
            {isOpen ? <X size={24} className="text-slate-700" /> : <Menu size={24} className="text-slate-700" />}
          </button>
        </div>

        {isOpen && (
          <div className="lg:hidden pb-4 border-t border-slate-100" data-testid="mobile-menu">
            <nav className="flex flex-col space-y-1 pt-3">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsOpen(false)}
                  className={`px-4 py-3 rounded-lg text-sm font-semibold transition-all ${
                    isActive(link.path)
                      ? 'bg-blue-50 text-[#1B6FE3]'
                      : 'text-slate-700 hover:bg-slate-50'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <Link
                to="/contact"
                onClick={() => setIsOpen(false)}
                className="mx-4 mt-2 btn-primary text-center justify-center"
              >
                Inscrire mon enfant
              </Link>
              <Link
                to="/login"
                onClick={() => setIsOpen(false)}
                className="mx-4 flex items-center justify-center text-sm text-slate-600 font-semibold py-2"
              >
                <Lock size={14} className="mr-1.5" />
                Intranet
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
